export default __webpack_public_path__ + "static/media/dispatched_default_noeld_selected.62f41110.svg";